var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.screen === 'mobile' ? '' : 'has-padding-right-55 has-padding-left-55'},[_c('business-list-page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }